module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Employee",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'auto'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      },
      "show": _vm.checkNepaliDateOrEnglish
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [(!_vm.displayOnly) ? _c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-6 p-md-10",
          attrs: {
            "this": ""
          }
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addEmployee.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayOnly) ? _c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-6 p-md-10",
          attrs: {
            "this": ""
          }
        }, [_c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Close"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeDialog.apply(null, arguments)
            }
          }
        })], 1)]) : _vm._e()]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "employeeId"
    }
  }, [_vm._v("Employee Id"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "employeeId"
    },
    model: {
      value: (_vm.employeeId),
      callback: function($$v) {
        _vm.employeeId = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "employeeId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "employeeName"
    }
  }, [_vm._v("Employee Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "employeeName"
    },
    model: {
      value: (_vm.employeeName),
      callback: function($$v) {
        _vm.employeeName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "employeeName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("PAN Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "panNo"
    },
    model: {
      value: (_vm.panNo),
      callback: function($$v) {
        _vm.panNo = $$v
      },
      expression: "panNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "pfNumber"
    }
  }, [_vm._v("PF Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "pfNumber"
    },
    model: {
      value: (_vm.pfNumber),
      callback: function($$v) {
        _vm.pfNumber = $$v
      },
      expression: "pfNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "cifNo"
    }
  }, [_vm._v("Cif Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "cifNo"
    },
    model: {
      value: (_vm.cifNo),
      callback: function($$v) {
        _vm.cifNo = $$v
      },
      expression: "cifNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "bankAccountNumber"
    }
  }, [_vm._v("Bank Account No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "bankAccountNumber"
    },
    model: {
      value: (_vm.bankAccountNumber),
      callback: function($$v) {
        _vm.bankAccountNumber = $$v
      },
      expression: "bankAccountNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "contactNumber"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactNumber"
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = $$v
      },
      expression: "contactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Salary Status")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('RadioButton', {
    attrs: {
      "id": "active",
      "name": "Active",
      "value": "ACTIVE"
    },
    model: {
      value: (_vm.salaryStatus),
      callback: function($$v) {
        _vm.salaryStatus = $$v
      },
      expression: "salaryStatus"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "inactive",
      "name": "Inactive",
      "value": "INACTIVE"
    },
    model: {
      value: (_vm.salaryStatus),
      callback: function($$v) {
        _vm.salaryStatus = $$v
      },
      expression: "salaryStatus"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inactive"
    }
  }, [_vm._v("InActive")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Join Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.dateOfJoin),
      callback: function($$v) {
        _vm.dateOfJoin = $$v
      },
      expression: "dateOfJoin"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "dateOfJoin"
    },
    model: {
      value: (_vm.dateOfJoin),
      callback: function($$v) {
        _vm.dateOfJoin = $$v
      },
      expression: "dateOfJoin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Group")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.employeeGroupLists,
      "optionLabel": "value",
      "placeholder": "Select Employee Group",
      "filter": true,
      "showClear": true,
      "id": "employeeGroup"
    },
    model: {
      value: (_vm.employeeGroupId),
      callback: function($$v) {
        _vm.employeeGroupId = $$v
      },
      expression: "employeeGroupId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Sub Group")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.employeePositionLists,
      "optionLabel": "value",
      "placeholder": "Select Employee Position",
      "filter": true,
      "showClear": true,
      "id": "employeePosition"
    },
    model: {
      value: (_vm.employeePositionId),
      callback: function($$v) {
        _vm.employeePositionId = $$v
      },
      expression: "employeePositionId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Sub Child Group")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.employeePositionSubGroupLists,
      "optionLabel": "value",
      "placeholder": "Select Sub Child Position",
      "filter": true,
      "showClear": true,
      "id": "subGroupChildId"
    },
    model: {
      value: (_vm.subGroupChildId),
      callback: function($$v) {
        _vm.subGroupChildId = $$v
      },
      expression: "subGroupChildId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Supervisor 1")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "optionLabel": "name",
      "options": _vm.employeeDropdownList,
      "placeholder": "Select Supervisor",
      "filter": true,
      "showClear": true,
      "id": "supervisor1"
    },
    model: {
      value: (_vm.supervisor1),
      callback: function($$v) {
        _vm.supervisor1 = $$v
      },
      expression: "supervisor1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Supervisor 2")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "optionLabel": "name",
      "options": _vm.employeeDropdownList,
      "placeholder": "Select Supervisor",
      "filter": true,
      "showClear": true,
      "id": "supervisor2"
    },
    model: {
      value: (_vm.supervisor2),
      callback: function($$v) {
        _vm.supervisor2 = $$v
      },
      expression: "supervisor2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Work Shift")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "optionLabel": "name",
      "options": _vm.workShifts,
      "placeholder": "Work Shift",
      "filter": true,
      "showClear": true,
      "id": "workShift"
    },
    model: {
      value: (_vm.workShift),
      callback: function($$v) {
        _vm.workShift = $$v
      },
      expression: "workShift"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Cr Account Ledger")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "optionLabel": "name",
      "options": _vm.accountMasterList,
      "placeholder": "Select One",
      "filter": true,
      "showClear": true,
      "id": "account"
    },
    model: {
      value: (_vm.accountMasterId),
      callback: function($$v) {
        _vm.accountMasterId = $$v
      },
      expression: "accountMasterId"
    }
  })], 1), _vm._v(" "), (!this.editing) ? _c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "value": _vm.payHeadList,
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Pay Head",
      "field": "name"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount",
      "field": "amount"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('InputText', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 770423615)
  })], 1) : _c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "value": _vm.payheadEditingList,
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Pay Heads",
      "field": "name"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount",
      "field": "amount"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('InputText', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('employeeList', {
    on: {
      "edit-employee": _vm.editEmployee,
      "view-employee": _vm.viewEmployee
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2724aebb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/employee.vue
// module id = 2101
// module chunks = 0